import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { AuthStore } from '../auth/store/auth-store';

/**
 * A `CanActivate` guard that only allows the activation of a route, if the user is authenticated. Unauthenticated
 * users will instead be redirected to the `redirectUrl`. In case of a redirect, the attempted URL will be added as
 * a query parameter called `redirectTo`.
 * @param redirectUrl The `URL` to which unauthenticated users should be redirected to.
 */
export const canActivateIfAuthenticated: (redirectUrl: string) => CanActivateFn = (redirectUrl: string): CanActivateFn => {
    return async (_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> => {
        const authStore: AuthStore = inject(AuthStore);
        const router: Router = inject(Router);

        await authStore.authStateReady();

        if (!authStore.user()) {
            return router.createUrlTree(
                [ redirectUrl ],
                {
                    queryParams: { redirectTo: state.url },
                },
            );
        }

        return true;
    };
};